import React, { ReactNode } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsErrorBoundary, withAITracking } from '@microsoft/applicationinsights-react-js';
import NextError from 'next/error';
import { AppInsightsContext, ReactPlugin } from './AzureAppInsightsContext';

const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env.NEXT_PUBLIC_APPINSIGHTS_INSTRUMENTATION_KEY || 'db59a239-686c-4da2-821c-574613be9027',
    enableAutoRouteTracking: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxPerfTracking: true,
    isBrowserLinkTrackingEnabled: true,
    extensions: [reactPlugin],
  },
});

appInsights.loadAppInsights();

const AppInsightsErrorFallback = () => <NextError statusCode={500} />;

const AzureAppInsightsElement = ({ children }: { children: ReactNode | undefined }) => {
  return (
    <AppInsightsContext value={reactPlugin}>
      <AppInsightsErrorBoundary appInsights={reactPlugin} onError={AppInsightsErrorFallback}>
        {children}
      </AppInsightsErrorBoundary>
    </AppInsightsContext>
  );
};

export const AzureAppInsights = withAITracking(reactPlugin, AzureAppInsightsElement);
